/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const removeAuditDates = (payload) => {
    delete payload.created_at;
    delete payload.updated_at;
    return payload;
};

export { removeAuditDates };
